/* ------------------------------------------------------------------------ */
/*		File: cmpShare.tsx                                                  */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICard } from "./cmpShare.d";
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    InstapaperShareButton,
    TelegramShareButton,
    RedditShareButton,
    FacebookMessengerShareButton,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    WhatsappIcon,
    InstapaperIcon,
    TelegramIcon, 
    RedditIcon,
    FacebookMessengerIcon,

} from 'react-share';

import "./cmpShare.css"


/* ------------------------------------------------------------------------ */

const Share: React.FC<ICard> = ({url, title, description}) => {
    return (
        <div className="card_share">
            <div className="card_share_description">{description}</div>
            <div className="card_share_content">
                <FacebookShareButton url={url} title={title}>
                    <FacebookIcon size={32} round={true} />
                </FacebookShareButton>

                <FacebookMessengerShareButton url={url} title={title} appId="">
                    <FacebookMessengerIcon size={32} round={true} />
                </FacebookMessengerShareButton>

                <TwitterShareButton url={url} title={title}>
                    <TwitterIcon size={32} round={true} />
                </TwitterShareButton>

                <LinkedinShareButton url={url}>
                    <LinkedinIcon size={32} round={true} />
                </LinkedinShareButton>

                <WhatsappShareButton url={url} title={title} separator=":: ">
                    <WhatsappIcon size={32} round={true} />
                </WhatsappShareButton>

                <TelegramShareButton url={url} title={title} >
                    <TelegramIcon size={32} round={true} />
                </TelegramShareButton>

                <RedditShareButton url={url} title={title} >
                    <RedditIcon size={32} round={true} />
                </RedditShareButton>
            </div>
        </div>
    )
}
export default Share;